import * as React from 'react';
export const IcTropicalStorm = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M17 6s.7-1.39 3.25-2.44c.46-.19.4-.87-.09-.96C9.65.72 6 7 6 7s-1.39-.7-2.43-3.25c-.19-.46-.87-.4-.96.09C.73 14.4 7.01 18 7.01 18s-.69 1.39-3.24 2.43c-.47.19-.4.88.09.96C14.38 23.16 18 16 18 16s1.4 1.4 2.44 4.19c.18.47.87.41.96-.09C23.26 9.52 17 5.99 17 5.99V6zm-5 9c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3z'
      fill='currentColor'
    />
  </svg>
);
